var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckmarkFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.0001 8.4142C15.3906 8.02367 15.3906 7.39051 15.0001 6.99999C14.6096 6.60946 13.9764 6.60946 13.5859 6.99999L8.34947 12.2364L6.05224 9.5563C5.69282 9.13698 5.06152 9.08841 4.6422 9.44784C4.22287 9.80726 4.17431 10.4386 4.53373 10.8579L7.53373 14.3579C7.715 14.5694 7.97627 14.6957 8.25461 14.7064C8.53295 14.717 8.80313 14.6112 9.00009 14.4142L15.0001 8.4142Z",
    fill: "#1AC057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkFlat);
export default __webpack_public_path__ + "static/media/green-checkmark-flat.a2568aa80dbbc3023e6e10f65c25fc54.svg";
export { ForwardRef as ReactComponent };